// extracted by mini-css-extract-plugin
export var copyIcon = "_yn-2";
export var discountCard = "_yn-0";
export var discountCode = "_yn-3";
export var discountContent = "_yn-1";
export var loadingCard = "_yn-4";